import { render, staticRenderFns } from "./kindChooseViewzlSeventh.vue?vue&type=template&id=8f3b6c9c&scoped=true"
import script from "./kindChooseViewzlSeventh.vue?vue&type=script&lang=js"
export * from "./kindChooseViewzlSeventh.vue?vue&type=script&lang=js"
import style0 from "./kindChooseViewzlSeventh.vue?vue&type=style&index=0&id=8f3b6c9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3b6c9c",
  null
  
)

export default component.exports